$(document).ready(function() {
    
    // 1. Quando si clicca su QUALSIASI blocco video
    $('[data-zg-role="open_video_modal"]').on('click', function(e) {
        e.preventDefault(); 
        
        // --- MODIFICA 1: Gestione del marcatore ---
        // Rimuove il marcatore da qualsiasi altro video che potrebbe averlo
        $('[data-zg-role="open_video_modal"].is-active-video').removeClass('is-active-video');
        // Aggiunge il marcatore SOLO al video che è stato cliccato
        $(this).addClass('is-active-video');

        const backgroundVideo = $(this).find('video').get(0);
        if (backgroundVideo) {
            backgroundVideo.pause();
        }

        const youtubeUrl = $(this).attr('href');
        let videoId;
        try {
            const url = new URL(youtubeUrl);
            videoId = url.searchParams.get('v');
        } catch (error) {
            console.error("URL di YouTube non valido:", youtubeUrl);
            return;
        }

        if (videoId) {
            const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
            const iframeHtml = `<iframe src="${embedUrl}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
            $('#youtube-player-container').html(iframeHtml);
            $('#blog-video-overlay').addClass('visible');
        }
    });

    // 2. Funzione per chiudere l'overlay (MODIFICATA)
    function closeOverlay() {
        $('#blog-video-overlay').removeClass('visible');
        $('#youtube-player-container').html('');
        
        // --- MODIFICA 2: Riavvia il video corretto ---
        // Cerca il blocco che ha il nostro marcatore
        const activeVideoBlock = $('[data-zg-role="open_video_modal"].is-active-video');
        
        if (activeVideoBlock.length > 0) {
            // Trova il video DENTRO quel blocco e fallo ripartire
            const backgroundVideo = activeVideoBlock.find('video').get(0);
            if (backgroundVideo) {
                backgroundVideo.play();
            }
            // Rimuovi il marcatore, così è pronto per il prossimo click
            activeVideoBlock.removeClass('is-active-video');
        }
    }
	

    // 3. Associa la funzione di chiusura (la logica non cambia)
    $('#blog-video-overlay .close-overlay').on('click', closeOverlay);
    
    $('#blog-video-overlay').on('click', function(e) {
        if ($(e.target).is('#blog-video-overlay')) {
            closeOverlay();
        }
    });

    $(document).on('keydown', function(e) {
        if (e.key === "Escape" && $('#blog-video-overlay').hasClass('visible')) {
            closeOverlay();
        }
    });

});